// src/app/services/auth.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private http: HttpClient) {}

  login(email: string, password: string): Observable<any> {
    return this.http.post<{ token: string }>(`${environment.apiUrl}/auth/login`, { email, password });
  }

  logout(): Observable<any>{
    return this.http.get<{ token: string }>(`${environment.apiUrl}/auth/logout`);
  }

  register(user): Observable<any>{
    return this.http.post<{ token: string }>(`${environment.apiUrl}/auth/register`, user);
  }

  requestPassword(user): Observable<any>{
    return this.http.post<{ token: string }>(`${environment.apiUrl}/auth/request-password`, user);
  }

  changePassword(currentPassword: string, newPassword: string): Observable<any> {
    return this.http.put(`${environment.apiUrl}/auth/change-password`, { currentPassword, newPassword });
  }
}
